import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { GetPunchoutIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import { PunchoutIdentityState } from "@TKCCP/Store/Data/PunchoutIdentity/PunchoutIdentityState";
import { PunchoutIdentityCollectionModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: PunchoutIdentityState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/PunchoutIdentity/BeginLoadIdentities": (
        draft: Draft<PunchoutIdentityState>,
        action: { parameter: GetPunchoutIdentityApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/PunchoutIdentity/CompleteLoadIdentities": (
        draft: Draft<PunchoutIdentityState>,
        action: { parameter: GetPunchoutIdentityApiParameter; collection: PunchoutIdentityCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.punchoutIdentityList!,
            // order => storeIdByOrderNumber(draft, order),
        );
    },
    "Data/PunchoutIdentity/Reset": () => {
        return initialState;
    },
};

// function storeIdByOrderNumber(draft: Draft<OrdersState>, order: OrderModel) {
//     if (order.erpOrderNumber) {
//         draft.idByOrderNumber[order.erpOrderNumber] = order.id;
//     }
//     if (order.webOrderNumber) {
//         draft.idByOrderNumber[order.webOrderNumber] = order.id;
//     }
// }
const punchoutreducer1 = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataPunchoutIdentity1 = punchoutreducer1;
